/* eslint-disable react/no-multi-comp */
import React from 'react';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import cn from 'classnames';
import { func, string } from 'prop-types';

import { DATA_TEST_ID } from '~constants/tests';
import { hyphensToCamelCase } from '~utils/functions';
import { DISPATCH_METHODS } from '~constants/address';

import { DISPATCH_METHODS_CONFIG } from '../../constants';

import styles from './styles.module.scss';
import { DELIVERY_ICONS_MAPPER } from './constants';

function DispatchMethods({ dispatchType, handleOpenDAPModal, address }) {
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const { templateModel } = useSelector((state) => state.core);
  const { hasIcon, hasArrow, hasExtraWord } = DISPATCH_METHODS_CONFIG[templateModel];

  const getIcon = (active, item) => {
    const IconImage = active ? DELIVERY_ICONS_MAPPER[item]?.active : DELIVERY_ICONS_MAPPER[item]?.inactive;
    return IconImage && <img src={IconImage} className={styles[`icon${templateModel}`]} />;
  };

  return (
    <div className="row middle center m-right-5">
      {Object.values(DISPATCH_METHODS).map((item) => {
        const active = dispatchType === item;
        return (
          <button
            key={item}
            type="button"
            className={cn('row middle center', styles[`dispatchMethods${templateModel}`], {
              [styles.active]: active,
              [styles.secondaryHeader]: isSecondaryHeader
            })}
            onClick={handleOpenDAPModal}
            data-testid={`${DATA_TEST_ID.deliveryOrPickupSelector}-${item}`}>
            {hasIcon && getIcon(active, item)}
            <span
              className={cn(styles[`text${templateModel}`], {
                [styles.active]: active,
                [styles.secondaryHeader]: isSecondaryHeader
              })}>
              {i18next.t(`Actionlinks:${hyphensToCamelCase(item)}`)}
              {hasExtraWord && item === DISPATCH_METHODS.DELIVERY && !address && i18next.t('Actionlinks:or')}
            </span>
          </button>
        );
      })}
      {hasArrow && (
        <i
          className={cn('icon-angle-down', styles[`icon${templateModel}`], {
            [styles.secondaryHeader]: isSecondaryHeader
          })}
        />
      )}
    </div>
  );
}

DispatchMethods.propTypes = {
  address: string,
  dispatchType: string,
  handleOpenDAPModal: func
};

export default DispatchMethods;
